import { render, staticRenderFns } from "./CurrenciesAndBalance.vue?vue&type=template&id=057572c6&"
import script from "./CurrenciesAndBalance.vue?vue&type=script&lang=js&"
export * from "./CurrenciesAndBalance.vue?vue&type=script&lang=js&"
import style0 from "./CurrenciesAndBalance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports